export const CHANGE_FORMULA_MATCH =
  'app/TextMessaging/TextMessageVariant/CHANGE_FORMULA_MATCH';

export const CHANGE_CONTENT =
  'app/TextMessaging/TextMessageVariant/CHANGE_CONTENT';
